import { NAMESPACE } from '../packages/constants/dist/index.js';
import { wait } from './wait.js';

const GET_CRNT_ELEMENTS_FROM_STRING_LOG_MESSAGES = {
  ERROR: "Could not get Current custom elements from string. Returning empty set"
};
function getCrntElementsFromString(input, namespace = NAMESPACE) {
  try {
    const regex = new RegExp(`(?<=<)${namespace}-[a-zA-Z0-9\\-]+(?=\\s|>)`, "g");
    const matches = [...input.matchAll(regex)];
    const tags = matches.reduce((acc, [match]) => {
      if (!acc.includes(match)) {
        acc.push(match);
      }
      return acc;
    }, []);
    return tags;
  } catch (error) {
    console.error(GET_CRNT_ELEMENTS_FROM_STRING_LOG_MESSAGES.ERROR, error);
    return [];
  }
}
const WHEN_CRNT_ELEMENTS_ARE_DEFINED_LOG_MESSAGES = {
  ERROR: "Could not define custom elements",
  FULFILLED: "Defined custom elements",
  REJECTED: "Could not retrieve custom element definition in CustomElementRegistry",
  TIMEOUT: "Defining custom elements timed out"
};
async function whenCrntElementsAreDefined(customElementTagNames, timeout = 500) {
  const rejected = new Set(customElementTagNames);
  const fulfilled = /* @__PURE__ */ new Set();
  let timedOut = false;
  await Promise.race([
    Promise.allSettled(
      customElementTagNames.map(async (tag) => {
        await customElements.whenDefined(tag);
        rejected.delete(tag);
        fulfilled.add(tag);
        return tag;
      })
    ),
    // Timeout at x amount of ms to break long running definitions
    wait(timeout).then(() => {
      timedOut = true;
    })
  ]);
  if (timedOut) {
    console.warn(WHEN_CRNT_ELEMENTS_ARE_DEFINED_LOG_MESSAGES.TIMEOUT);
  }
  if (fulfilled.size > 0) {
    console.debug(WHEN_CRNT_ELEMENTS_ARE_DEFINED_LOG_MESSAGES.FULFILLED, [...fulfilled]);
  }
  if (rejected.size > 0) {
    console.warn(WHEN_CRNT_ELEMENTS_ARE_DEFINED_LOG_MESSAGES.REJECTED, [...rejected]);
  }
}

export { GET_CRNT_ELEMENTS_FROM_STRING_LOG_MESSAGES, WHEN_CRNT_ELEMENTS_ARE_DEFINED_LOG_MESSAGES, getCrntElementsFromString, whenCrntElementsAreDefined };
